import {
  Button,
  Input,
  Select,
  SelectItem,
  Textarea,
  useDisclosure,
} from "@nextui-org/react";
import React, { useState } from "react";
import { useEffect } from "react";
import {
  PublishData,
  capitalize,
  getDataWithFilterUrl,
} from "../../controllers/APIController";
import MarkdownEditor from "../Dashboard/MarkdownEditor";
import { useNavigate, useParams } from "react-router-dom";
import BreadCrumbsPage from "../../components/BreadCrumbsPage";
import useGetAllOrganization from "../../hooks/useGetAllOrganization";
import LoadingPage from "../../components/Loader/LoadingPage";
import CreateMarkDownWithAI from "./CreateMarkDownWithAI";
import TipTap from "../MarkdownEditor/Tiptap";
import { useQuery, useQueryClient } from "@tanstack/react-query";

const createUploadDataForPolicyBuilder = (
  data,
  OrgInfo,
  markDownContent,
  metricValueList
) => {
  const uploadData = {
    Name: data.name,
    Description: data.description,
    Organization: OrgInfo,
  };
  if (data?.policyType === "policy") {
    uploadData.DomainId = +data.domain;
    uploadData.PolicyFramework = markDownContent;
  } else if (data?.policyType === "procedure") {
    uploadData.PolicyId = data.policy;
    uploadData.ControlMetrics = { controlMetrics: metricValueList };
    uploadData.ProcedureFramework = markDownContent;
  }

  return uploadData;
};
const pulizirePolicyName = {
  domain: "domains",
  policy: "policies",
  procedure: "procedures",
};

const PoliciesCreateBuilder = () => {
  // const [isLoading, setisLoading] = useState(true);
  const [userRole, setUserRole] = useState("");
  const [metricValueList, setMetricValueList] = useState([]);
  const [intial, setInitial] = useState(false);
  const [markDownContent, setMarkDownContent] = useState("");

  const [policyDetails, setPolicyDetails] = useState({
    name: "",
    description: "",
    policyType: "",
    domain: null,
    policy: null,
  });
  const [allDomainPolicyProcedure, setAllDomainPolicyProcedure] = useState({
    domainList: [],
    policyList: [],
  });
  const [metricFormList, setMetricFormList] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});

  const {
    isOpen: isModalOpen,
    onOpen: onModalOpen,
    onOpenChange: onModalOpenChange,
  } = useDisclosure();

  const navigate = useNavigate();
  const clientQuery = useQueryClient();
  const { _orgId: currOrg } = useParams();

  const policyTypeList = [
    { id: "domain", title: "Domain" },
    { id: "policy", title: "Policy" },
    { id: "procedure", title: "Procedure" },
  ];

  const UserLogged = JSON.parse(sessionStorage.getItem("userData"));
  const OrgInfo = UserLogged && UserLogged.user.LastOrgId;
  const orgFilterUrl = "filters[Organization][id][$eqi]=" + OrgInfo;

  const changeHandler = (key, value) => {
    setPolicyDetails((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };
  const validationHandler = () => {
    let isValid = true;
    const errorMessage = {};
    if (!policyDetails?.name || policyDetails?.name?.trim() === "") {
      errorMessage["name"] = "Name is required!";
      isValid = false;
    }
    if (
      !policyDetails?.description ||
      policyDetails?.description?.trim() === ""
    ) {
      errorMessage["description"] = "Description is required!";
      isValid = false;
    }
    if (
      !policyDetails?.policyType ||
      policyDetails?.policyType?.trim() === ""
    ) {
      errorMessage["policyType"] = "Type is required!";
      isValid = false;
    }
    if (
      policyDetails?.policyType === "policy" &&
      (!policyDetails?.domain || policyDetails?.domain?.trim() === "")
    ) {
      errorMessage["domain"] = "domain is required!";
      isValid = false;
    }
    if (
      policyDetails?.policyType === "procedure" &&
      (!policyDetails?.policy || policyDetails?.policy?.trim() === "")
    ) {
      errorMessage["policy"] = "Policy is required!";
      isValid = false;
    }
    setValidationErrors(errorMessage);

    return isValid;
  };
  const submitHandler = async () => {
    const isValid = validationHandler();
    if (!isValid) {
      return;
    }

    const uploadData = createUploadDataForPolicyBuilder(
      policyDetails,
      OrgInfo,
      markDownContent,
      metricValueList
    );

    const collectionName = pulizirePolicyName?.[policyDetails?.policyType];

  await PublishData({ data: uploadData }, collectionName);
     clientQuery.invalidateQueries({ queryKey: ["procedures", orgFilterUrl] });
     clientQuery.invalidateQueries({ queryKey: ["policies", orgFilterUrl] });
     clientQuery.invalidateQueries({ queryKey: ["domains", orgFilterUrl] });
     

    navigate(-1);
  };
  //   const data = {};

  const { data: metricData, isLoading } = useQuery({
    queryKey: ["metrics", orgFilterUrl],
    queryFn: () => getDataWithFilterUrl("metrics", orgFilterUrl),
  });
  
    const { data: domainsData, isPending } = useQuery({
      queryKey: ["domains", orgFilterUrl],
      queryFn: () => getDataWithFilterUrl("domains", orgFilterUrl),
    });


    const { data: policiesData } = useQuery({
      queryKey: ["policies", orgFilterUrl],
      queryFn: () => getDataWithFilterUrl("policies", orgFilterUrl),
    });



   

  useEffect(() => {
  
        let list = metricData?.data;
        list?.sort((a, b) => {
          if (
            a?.attributes?.Name.trim().toLowerCase() <
            b?.attributes?.Name.trim().toLowerCase()
          ) {
            return -1;
          }
          if (
            a?.attributes?.Name.trim().toLowerCase() >
            b?.attributes?.Name.trim().toLowerCase()
          ) {
            return 1;
          }
          return 0;
        });

        list = list?.map((item) => {
          return {
            id: item.id,
            title: item?.attributes?.Name,
          };
        });
        setMetricFormList(list);
        
      
     
  }, [metricData]);

  useEffect(() => {
    const policyList = [];
    const domainList = [];
    let randomId = 0;
    domainsData?.data?.forEach((element) => {
      domainList.push({
        randomId: randomId++,
        id: element.id,
        name: element?.attributes?.Name,
        description: element?.attributes?.Description || "--",
      });
    });
    policiesData?.data?.forEach((element) => {
      policyList.push({
        randomId: randomId++,
        id: element.id,
        name: element?.attributes?.Name,
        description: element?.attributes?.Description || "--",
        type: "policy",
      });
    });
    setAllDomainPolicyProcedure({
      domainList,
      policyList,
    });
  }, [policiesData, domainsData]);


  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Page Header */}
      <div className="bg-white border-b border-neutral-200 px-8 py-6 shadow-sm">
        <div className="flex items-center justify-between max-w-full">
          <div>
            <h1 className="text-2xl font-semibold text-neutral-900">
              Policy Builder
            </h1>
            <p className="text-sm text-neutral-600 mt-1">
              Create and manage ESG policies, domains, and procedures for your
              organization
            </p>
          </div>
          <div className="flex items-center gap-4">
            <Button
              color="secondary"
              variant="light"
              size="sm"
              onClick={() => navigate(-1)}
              className="text-neutral-600 hover:text-neutral-800 px-6 font-medium"
            >
              Cancel
            </Button>
            <Button
              color="primary"
              size="sm"
              onClick={submitHandler}
              className="bg-primary-600 hover:bg-primary-700 text-white px-6 font-medium"
            >
              Create
            </Button>
          </div>
        </div>
      </div>

      <BreadCrumbsPage>
        <div className="w-full px-4 py-2">
          {/* Policy Builder Section */}
          <div className="bg-white rounded-lg border border-neutral-200 shadow-sm overflow-hidden">
            <div className="px-6 py-4 border-b border-neutral-200">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-lg font-semibold text-neutral-900">
                    Create New Policy Framework
                  </h3>
                  <p className="text-sm text-neutral-600 mt-1">
                    Fill in the details below to create your policy framework
                  </p>
                </div>
              </div>
            </div>

            <div className="p-6">
              <LoadingPage
                isLoading={isLoading || isPending}
                loadingText="Loading policy builder..."
              >
                <div className="space-y-6">
                  {/* Policy Type Selection */}
                  <div className="space-y-4">
                    {/* <h4 className="text-lg font-medium text-neutral-800">Policy Type</h4> */}

                    <Select
                      label="Policy Type"
                      placeholder="Choose a Category"
                      variant="bordered"
                      selectionMode="single"
                      labelPlacement="outside"
                      className="max-w-md"
                      selectedKeys={
                        policyDetails?.policyType
                          ? new Set([policyDetails.policyType])
                          : new Set()
                      }
                      onSelectionChange={(event) =>
                        changeHandler("policyType", Array.from(event)[0])
                      }
                      errorMessage={validationErrors["policyType"]}
                      isInvalid={validationErrors["policyType"]}
                    >
                      {policyTypeList?.map((item) => (
                        <SelectItem
                          key={item.id}
                          value={item.title}
                          className="py-2"
                        >
                          {item.title}
                        </SelectItem>
                      ))}
                    </Select>
                  </div>

                  {/* Basic Information */}
                  {policyDetails?.policyType &&
                    policyDetails?.policyType !== "" && (
                      <div className="space-y-4">
                        <div className="border-t border-neutral-200 pt-6">
                          <h4 className="text-lg font-medium text-neutral-800">
                            Basic Information
                          </h4>

                          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-4">
                            <Input
                              type="text"
                              isRequired
                              label="Name"
                              placeholder="Enter policy name"
                              variant="bordered"
                              labelPlacement="outside"
                              value={policyDetails?.name}
                              onChange={(event) => {
                                changeHandler("name", event.target.value);
                              }}
                              isInvalid={validationErrors["name"]}
                              errorMessage={validationErrors["name"]}
                            />

                            <div className="lg:col-span-2">
                              <Textarea
                                label="Description"
                                isRequired
                                value={policyDetails?.description}
                                placeholder="Provide a detailed description of your policy"
                                variant="bordered"
                                labelPlacement="outside"
                                minRows={3}
                                onChange={(event) => {
                                  changeHandler(
                                    "description",
                                    event.target.value
                                  );
                                }}
                                isInvalid={validationErrors["description"]}
                                errorMessage={validationErrors["description"]}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                  {/* Domain Selection for Policy */}
                  {policyDetails?.policyType === "policy" && (
                    <div className="space-y-4">
                      <div className="border-t border-neutral-200 pt-6">
                        {/* <h4 className="text-lg font-medium text-neutral-800">Domain Selection</h4> */}

                        <Select
                          label="Domain"
                          placeholder="Choose a Domain"
                          variant="bordered"
                          selectionMode="single"
                          labelPlacement="outside"
                          className="max-w-md mt-4"
                          selectedKeys={
                            policyDetails?.domain
                              ? new Set([policyDetails.domain])
                              : new Set()
                          }
                          onSelectionChange={(event) => {
                            const selectedKey = Array.from(event)[0];
                            const selectedDomain =
                              allDomainPolicyProcedure?.domainList?.find(
                                (item) => item.id == selectedKey
                              );
                            changeHandler(
                              "domain",
                              selectedDomain?.id || selectedKey
                            );
                          }}
                          errorMessage={validationErrors["domain"]}
                          isInvalid={validationErrors["domain"]}
                        >
                          {allDomainPolicyProcedure?.domainList?.map((item) => (
                            <SelectItem
                              key={item.id}
                              value={item.name}
                              className="py-2"
                            >
                              <div className="flex flex-col gap-1">
                                <span className="font-medium text-neutral-900">
                                  {item.name}
                                </span>
                                <span className="text-xs text-neutral-500">
                                  {item.description}
                                </span>
                              </div>
                            </SelectItem>
                          ))}
                        </Select>
                      </div>
                    </div>
                  )}

                  {/* Policy Selection for Procedure */}
                  {policyDetails?.policyType === "procedure" && (
                    <div className="space-y-4">
                      <div className="border-t border-neutral-200 pt-6">
                        {/* <h4 className="text-lg font-medium text-neutral-800">Policy Selection</h4> */}

                        <Select
                          label="Choose Policy"
                          placeholder="Choose a policy"
                          variant="bordered"
                          selectionMode="single"
                          labelPlacement="outside"
                          className="max-w-md mt-4"
                          selectedKeys={
                            policyDetails?.policy
                              ? new Set([policyDetails.policy])
                              : new Set()
                          }
                          onSelectionChange={(event) => {
                            const selectedKey = Array.from(event)[0];
                            const selectedPolicy =
                              allDomainPolicyProcedure?.policyList?.find(
                                (item) => item.id == selectedKey
                              );
                            changeHandler(
                              "policy",
                              selectedPolicy?.id || selectedKey
                            );
                          }}
                          errorMessage={validationErrors["policy"]}
                          isInvalid={validationErrors["policy"]}
                        >
                          {allDomainPolicyProcedure?.policyList?.map((item) => (
                            <SelectItem
                              key={item.id}
                              value={item.name}
                              className="py-2"
                            >
                              <div className="flex flex-col gap-1">
                                <span className="font-medium text-neutral-900">
                                  {item.name}
                                </span>
                                <span className="text-xs text-neutral-500">
                                  {item.description}
                                </span>
                              </div>
                            </SelectItem>
                          ))}
                        </Select>
                      </div>
                    </div>
                  )}

                  {/* Control Metrics for Procedure */}
                  {policyDetails?.policyType === "procedure" && (
                    <div className="space-y-4">
                      <div className="border-t border-neutral-200 pt-6">
                        {/* <h4 className="text-lg font-medium text-neutral-800">Control Metrics</h4> */}

                        <Select
                          label="Control Metrics"
                          placeholder="Select any Metrics"
                          variant="bordered"
                          selectionMode="multiple"
                          labelPlacement="outside"
                          className="max-w-md mt-4"
                          selectedKeys={new Set(metricValueList)}
                          onSelectionChange={(event) =>
                            setMetricValueList(Array.from(event))
                          }
                        >
                          {metricFormList?.map((item) => (
                            <SelectItem
                              key={item.id}
                              value={item.title}
                              className="py-2"
                            >
                              {item.title}
                            </SelectItem>
                          ))}
                        </Select>
                      </div>
                    </div>
                  )}

                  {/* Markdown Editor */}
                  {(policyDetails?.policyType === "policy" ||
                    policyDetails?.policyType === "procedure") && (
                    <div className="space-y-4">
                      <div className="border-t border-neutral-200 pt-6">
                        <div className="flex items-center justify-between mb-4">
                          <h4 className="text-lg font-medium text-neutral-800">
                            Describe{" "}
                            {capitalize(policyDetails?.policyType || "")}
                          </h4>
                          <Button
                            size="sm"
                            color="warning"
                            onClick={onModalOpen}
                            className="bg-warning-500 hover:bg-warning-600 text-white font-medium"
                          >
                            Create with AI
                          </Button>
                        </div>

                        <div className="bg-neutral-50/50 rounded-lg border border-neutral-200 p-4">
                          <MarkdownEditor
                            descriptionContent={markDownContent}
                            setDescriptionContent={setMarkDownContent}
                            intial={intial}
                            setInitial={setInitial}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </LoadingPage>
            </div>
          </div>
        </div>
      </BreadCrumbsPage>
      <CreateMarkDownWithAI
        isOpen={isModalOpen}
        onOpen={onModalOpen}
        onOpenChange={onModalOpenChange}
        setInitial={setInitial}
        onSubmitHandler={(data) => {
          setMarkDownContent(data);
        }}
      />
    </div>
  );
};

export default PoliciesCreateBuilder;
